const mutedWarningMessages = ['TouchableWithoutFeedback is deprecated. Please use Pressable.']

function isMutedWarning(args: unknown[]): boolean {
  return args.some((arg) => typeof arg === 'string' && mutedWarningMessages.some((message) => arg.includes(message)))
}

export function installConsoleWarningFilter() {
  const originalWarn = console.warn.bind(console)

  console.warn = (...args: unknown[]) => {
    if (isMutedWarning(args)) {
      return
    }

    originalWarn(...args)
  }
}
